import Chart from 'chart.js';
/*
export function TimeSeries({ctx, labels, data1, data2, opts, label1, label2}) {
	return new Chart(ctx, {
		type: 'line',
		data: {
			labels,
			datasets: [{
				label: label1,
				backgroundColor: 'rgba(255, 99, 132, 0.2)',
				borderColor: 'rgba(255,99,132,1)',
				fill: false,
				data: data1,
			}, {
				label: label2,
				backgroundColor: 'rgba(137, 196, 244, 1)',
				borderColor: 'rgba(44, 130, 201, 1)',
				fill: false,
				data: data2,
			},
		},
		options: {
			title: {
				text: 'Chart.js Time Scale'
			},
			scales: {
				xAxes: [{
					type: 'time',
					time: {
						parser: timeFormat,
						tooltipFormat: 'll HH:mm'
					},
					scaleLabel: {
						display: true,
						labelString: 'Date'
					}
				}],
				yAxes: [{
					scaleLabel: {
						display: true,
						labelString: 'value'
					}
				}]
			},
		}
	});
}
*/
export function StackedBarChartWithLine({ctx, labels, data1, data2, data3, label1, label2, label3}) {
  return new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: label1,
            backgroundColor: 'rgba(54, 162, 235, 1)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            fill: false,
            data: data1,
            yAxisID: "y-axis-2"
          },
          {
            type: 'bar',
            label: label2,
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            data: data2
          },
          {
            type: 'bar',
            label: label3,
            backgroundColor: 'rgba(255, 206, 86, 1)',
            borderColor: 'rgba(255, 206, 86, 1)',
            borderWidth: 2,
            data: data3,
            yAxisID: "y-axis-1"
          },
        ]
      },
      options: {
        responsive: true,
				title:{
					text: ''
				},
				tooltips: {
					mode: 'index',
				},
				hover: {
					mode: 'index'
				},
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Time'
						}
					}],
					yAxes: [{
						stacked: false,
            position: "left",
            scaleLabel: {
							display: true,
							labelString: ''
						},
            id: "y-axis-1",
            ticks: {
              beginAtZero:true
            }
					},
          {
						stacked: false,
            position: "left",
            scaleLabel: {
							display: true,
							labelString: 'Temperature & Humidity'
						},
            id: "y-axis-1"
					},
          {
            type: "linear",
            display: true,
            position: "right",
            scaleLabel: {
							display: true,
							labelString: 'Precipitation (mm)'
						},
            gridLines: {
              color: "rgba(0, 0, 0, 0)"
            },ticks: {
              beginAtZero:true
            },
            id: "y-axis-2"
          }
        ]
				}
      }
  });
}



export function LineChart({ctx, labels, data, label}) {
  return new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            type: 'line',
            label: label,
            backgroundColor: 'rgba(1, 152, 117, 1)',
            borderColor: 'rgba(162, 222, 208, 1)',
            borderWidth: 2,
            fill: true,
            data,
            yAxisID: "y-axis-3"
          }
        ]
      },
      options: {
        responsive: true,
				title:{
					text: ''
				},
				tooltips: {
					mode: 'index',
				},
				hover: {
					mode: 'index'
				},
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Time'
						}
					}],
					yAxes: [{
            type: "linear",
            display: true,
            position: "left",
            scaleLabel: {
							display: false,
							labelString: 'Air Quality'
						},
            gridLines: {
              color: "rgba(0, 0, 0, 0)"
            },ticks: {
              beginAtZero: true
            },
            id: "y-axis-3"
          }
        ]
				}
      }
  });
}




































/* END */



// WEBPACK FOOTER //
// ./src/weather/components/charts/misc_chart.js